import { render, staticRenderFns } from "./ProgramStart.vue?vue&type=template&id=ae3b9a78&scoped=true&"
import script from "./ProgramStart.vue?vue&type=script&lang=js&"
export * from "./ProgramStart.vue?vue&type=script&lang=js&"
import style0 from "./ProgramStart.vue?vue&type=style&index=0&id=ae3b9a78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3b9a78",
  null
  
)

export default component.exports